// Static introductory text for the Assist sub-tab.

import React from "react";
import { Typography } from "@material-tailwind/react";

export function UsingAssistSection() {
    return (
        <div>
            <Typography
                variant="h5"
                className="ml-2 font-body text-black"
            >
                Using Gobby Assist
            </Typography>
            <Typography
                as="span"
                className="my-2 ml-2 font-body text-black"
            >
                If you activate Gobby Assist it will allow us to
                utilise AI tools such as Amazon Comprehend to
                support the creation of Themes and the analysis of
                Insights for your survey.
            </Typography>

            <Typography
                as="span"
                className="my-2 ml-2 font-body text-black"
            >
                The following types of questions and their responses
                will be excluded from Gobby Assist:
                <br />
                1. Preset and Mixed question types.
                <br />
                2. Questions where the &ldquo;Tag this as a &lsquo;demographic&rsquo;
                question&rdquo; toggle has been selected.
                <br />
                3. Questions where the &ldquo;Tag this as a question
                collecting Personally Identifiable Information
                (PII)&rdquo; toggle has been selected.
            </Typography>
        </div>
    );
}
